<template>

    <div v-if="currentErrand">

      <v-btn
        v-if="!isEndCustomer"
        class="ml-0 mb-3 hidden-sm-and-up"
        block
        color="primary"
        @click="$router.push('/')"
      >
        <v-icon
          left
          dark
        >keyboard_arrow_left</v-icon>
        {{ $t('errands.allErrands') }}
      </v-btn>

      <v-btn
        v-if="!isEndCustomer"
        class="ml-0 mb-3 hidden-xs-only"
        color="primary"
        @click="$router.push('/')"
      >
        <v-icon
          left
          dark
        >keyboard_arrow_left</v-icon>
        {{ $t('errands.allErrands') }}
      </v-btn>

      <!-- Mobile menu -->
      <div class="enter hidden-md-and-up ">
        <v-select
          :items="routes"
          item-text="title"
          item-value="path"
          solo
          :value="getCurrentlySelectedRoute"
          @input="navigate"
        ></v-select>

      </div>

      <!-- Menu bigger screens -->
      <v-tabs
        class="hidden-sm-and-down"
        background-color="transparent"
        slider-color="primary"
        right
      >

        <v-tab
          v-for="route in routes"
          :key="route.title"
          ripple
          exact
          active-class="active-tab"
          :to="route.path"
        > {{ route.title }} </v-tab>

      </v-tabs>

      <PolygonSubHeaderErrand class="mt-3" />

      <keep-alive>
        <router-view></router-view>
      </keep-alive>

    </div>
</template>

<script>
import repository from '@/core/repository/entity-repository'
import constants from '@/core/constants'
import toasts from '@/core/toasts'
import { mapActions } from 'vuex'
import { loadUnits } from '@/core/startup'

export default {
  activated() {
    this.getErrand()
    this.getMembers()
    loadUnits()
  },
  computed: {
    routes() {
      const routes = [
        {
          path: `/${this.errandId}`,
          title: this.$t('errand.overview')
        },
        {
          path: `/${this.errandId}/history`,
          title: this.$t('events.history')
        },
        {
          path: `/${this.errandId}/documents`,
          title: this.$t('events.document')
        },
        {
          path: `/${this.errandId}/information`,
          title: this.$t('contact.information')
        },
        {
          path: `/${this.errandId}/persons`,
          title: this.$t('contact.persons')
        }
      ]
      if (this.currentErrand.backend_system === constants.backendSystem.apps10 && this.hasFeature('useChat')) {
        routes.push({
          path: `/${this.errandId}/message-log`,
          title: this.$t('messages.heading')
        })
      }
      return routes
    },
    getCurrentlySelectedRoute() {
      const found = this.routes.find(
        ({ path }) => path === this.$router.currentRoute.path
      )
      const result = found ? found.path : null
      return result
    }
  },
  methods: {
    ...mapActions(['setActiveEntity', 'setMembers']),
    navigate(path) {
      this.$router.push(path)
    },
    async getErrand() {
      this.setActiveEntity({ key: 'errand', entity: null })
      try{
        const errand = await repository.getErrand(this.errandId)
        this.setActiveEntity({ key: 'errand', entity: errand })
      } catch(error) {
        toasts.error(this.$t('errand.loadError'), null)
        this.$router.push({ path: '/404' })
      }
    },
    async getMembers() {
      this.setMembers(null)
      try{
        const members = await repository.getMembers(this.errandId)
        this.setMembers(members)
      } catch(error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang=scss scoped>
.flex-corner {
  display: flex;
  justify-content: space-between;
}
.active-tab {
  color: rgba(var(--color-primary), 1) !important;
}
</style>
